module.exports = __webpack_public_path__ + "static/media/Paus soffa 2-sits med recliners pausakomb375hg detalj 2023 1.f54654d4.jpg";